import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const HeroSlider = () => {
  const [slides, setSlides] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  // const [loading, setLoading] = useState(true);
  const swiperRef = useRef(null);

  const folderId = "13ZvVHj6LDP7fg68mZoQUD7OauVYB-M73";
  const apiKey = "AIzaSyAAgFvKs3Vo5nuo_bkIY1ePkNqNsSmB33g";

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const url = `https://www.googleapis.com/drive/v3/files?q='${folderId}' in parents and mimeType contains 'image/' and trashed=false&pageSize=100&fields=files(id,name)&key=${apiKey}`;
        const response = await axios.get(url);

        console.log("Files found in Drive:", response.data.files.length);
        console.log("File names:", response.data.files.map(f => f.name));

        const formatted = response.data.files.map((file) => ({
          img: `https://drive.google.com/thumbnail?id=${file.id}&sz=w2000`,
          title: file.name.replace(/\.[^/.]+$/, ""),
        }));

        setSlides(formatted);
      } catch (err) {
        console.error(err);
      } finally {
        // setLoading(false);
      }
    };

    fetchImages();
  }, []);



  return (
    // <div className="hero-slider">
    <div
      className="hero-slider"
      style={{ cursor: "grab", pointerEvents: "auto", touchAction: "pan-y" }}
    >

      {/* <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        loop
        navigation
        autoplay={{ delay: 3000 }}
        speed={1200}
        pagination={{
          el: ".dot-pagination",
          clickable: true,
        }}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      > */}
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        loop={slides.length > 1}
        navigation
        observer={true}
        observeParents={true}
        grabCursor={true}
        touchEventsTarget="container"
        autoplay={{
          delay: 3000,
          disableOnInteraction: false, // IMPORTANT
          pauseOnMouseEnter: false,
        }}
        speed={1200}
        pagination={{
          el: ".dot-pagination",
          clickable: true,
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onTouchStart={(swiper) => {
          swiper.autoplay.stop();
        }}
        onTouchEnd={(swiper) => {
          swiper.autoplay.start();
        }}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      >

        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="slide-bg"
              style={{ backgroundImage: `url(${slide.img})` }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="dot-pagination"></div>

      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
        }}
      >
        <h2
          key={activeIndex}
          className="slide-overlay-title"
        >
          {slides[activeIndex]?.title}
        </h2>
      </div>

    </div>
  );
};


export default HeroSlider;
